<tt-page *ngIf="!!setting">
    <tt-page-heading *ngIf="!!setting" [ttModel]="setting.page_heading"></tt-page-heading>
    <tt-list class="col-xs-12 col-md-4 sp-0" [ttData]="itemsListRelatedTo"></tt-list>
</tt-page>
